import { Pixel, ScriptEvent } from '@propps-au/pixel-analytics-types'

const createConfig = (name: string): Pixel.EventConfig => ({
  amplitude: { dispatch: false },
  mailroom: { dispatch: true, topic: Pixel.PixelEventTopic.Script },
})

export const ScriptEventConfigs: Record<
  Pixel.ScriptEvent.EventType,
  Pixel.EventConfig
> = {
  [ScriptEvent.LISTING_PAGE_VISITED]: createConfig('listing-page-visited'),
  [ScriptEvent.BUTTON_CLICKED]: createConfig('button-clicked'),
}
